import React from "react";
import PropTypes from "prop-types";
import ClipLoader from "react-spinners/ClipLoader";
import { CCard } from "@coreui/react";
import { FaInfoCircle } from "react-icons/fa";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import "./CCardDashboard.css";

import {useTranslation} from "react-i18next";
import HealthStatusIndicator from "../../../../../../../components/HealthStatusIndicator/HealthStatusIndicator";
import { getHealthStatusByTag } from "../../../../../../config/thresholds";



const CCardDashboard = ({ 
  title,
  secondaryTitle = null, // Optional secondary title 
  number, 
  loading, 
  tooltipInfo,
  patientData = null, // Optional patient data for gender-specific thresholds
  healthMetricTag = null, // Optional tag for specific health metrics
}) => {

  const {t} = useTranslation();

  // Determine health status based on the metric tag
  const getCardHealthStatus = () => {
    if (loading || number === 'N/A' || number === undefined || number === null || !healthMetricTag) {
      return 'neutral';
    }

    // Get patient gender for gender-specific thresholds
    const gender = patientData?.sex?.toLowerCase() === 'f' ? 'female' : 'male';

    return getHealthStatusByTag(number, healthMetricTag, gender);
  };

  const healthStatus = getCardHealthStatus();




  return (
    <CCard className={title === t("cardiovascularRiskFactor") ? "background-ccard-blue" : "background-ccard"}>
      {!loading && (
        <>
          <div className={title === t("cardiovascularRiskFactor") ? "div-row-tootip-cardio-risk" : "div-row-tootip"}>
            <Tooltip
              title={<span className={title === t("cardiovascularRiskFactor") ? "tooltip-window-blue" : "tooltip-window"}
                dangerouslySetInnerHTML={{__html: tooltipInfo}}
              >
                </span>}
              arrow
            >
              <IconButton>
                <FaInfoCircle className={title === t("cardiovascularRiskFactor") ? "info-icon-blue" : "info-icon"} />
              </IconButton>
            </Tooltip>
          </div>

          {/* Health Status Indicator */}
          {healthStatus !== 'neutral' && (
            <HealthStatusIndicator 
              status={healthStatus}
              size="medium"
              position="top-left"
              showBorder={true}
            />
          )}

          <p className={title === t("cardiovascularRiskFactor") ? "widget-title-cardio-risk" : "widget-title"}>{title}</p>

          <span className={`widget-text-white ${healthStatus !== 'neutral' ? `health-status-${healthStatus}` : ''} ${title === t("cardiovascularRiskFactor") ? "widget-number-cardio-risk" : ""}`}>
            {number} {number !== "N/A" && (title === t("teeValue") || title === t("benedictValue")) ? " Kcal" : "" }
          </span>

          {secondaryTitle && (
            <p className="widget-secondary-title">{secondaryTitle}</p>
          )}
        </>
      )}
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <ClipLoader
            color={title === t("cardiovascularRiskFactor") ? "#ffffff" : "#204770"}
            loading={loading}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}
    </CCard>
  );
};

CCardDashboard.propTypes = {
  title: PropTypes.string.isRequired,
  secondaryTitle: PropTypes.string, // Optional secondary title
  number: PropTypes.any.isRequired,
  loading: PropTypes.bool.isRequired,
  tooltipInfo: PropTypes.string.isRequired,
  patientData: PropTypes.object, // Optional patient data for gender-specific thresholds
  healthMetricTag: PropTypes.string, // NEW: Unique identifier for health metric
};

export default CCardDashboard;
